export const getFirstVideoFrame = async file => {
  return new Promise((resolve, reject) => {
    const videoURL = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.src = videoURL;
    video.crossOrigin = "anonymous"; // Allow cross-origin access

    video.addEventListener("loadedmetadata", () => {
      video.currentTime = 0;
    });

    video.addEventListener("seeked", () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL("image/jpeg");
        URL.revokeObjectURL(videoURL);
        resolve(imageDataUrl);
      } else {
        reject("Failed to get canvas context");
      }
    });

    video.addEventListener("error", e => {
      reject(`Video error: ${e.message}`);
    });
  });
};
